import React from "react"

interface ComponentProps {
  name: string
  icon: Function
}

const ReportButtonSkeleton = (props: ComponentProps) => {
  return (
    <div className="animate-pulse flex items-center justify-between bg-white py-5.5 px-6 sm:py-9 sm:px-8 border shadow-pk-card border-gray-200 rounded-lg overflow-hidden">
      <div className="relative">
        <div className="absolute bg-green-500 rounded-md p-3.5">
          <props.icon className="h-7 w-7 text-white" aria-hidden="true" />
        </div>
        <div className="ml-20">
          <div className="text-gray-800 truncate text-lg mb-2">{props.name}</div>
          <div className="flex items-baseline">
            <div className="h-6 w-20 bg-gray-300 rounded"></div>
            <div className="ml-2 h-5 w-5 bg-gray-300 rounded-full"></div>
          </div>
        </div>
      </div>
      <div className="ml-2 h-6 w-6 bg-gray-300 rounded"></div>
    </div>
  )
}

export default ReportButtonSkeleton
